var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgcolor-grey",attrs:{"id":"main"}},[_c('div',{staticClass:"container inner inner-tab-sp-max layout-two"},[_c('router-view'),_c('SideBar',{attrs:{"menuName":'other'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }